import {
  FETCH_ONDUTY_SUCCESS,
  CREATE_ONDUTY,
  UPDATE_ONDUTY,
  DELETE_ONDUTY,
  SET_ONDUTY_ID,
} from "actions/types";
import { produce } from "immer";

const initialState = {
  OnDuty: [],
  onDutyId: -1,
  error: "",
};

const onDutyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key;
    switch (action.type) {
      case FETCH_ONDUTY_SUCCESS:
        draft.OnDuty = action.payload;
        draft.error = "";
        break;
      case CREATE_ONDUTY:
        draft.OnDuty = [action.payload, ...draft.OnDuty];
        draft.error = "";
        break;
      case UPDATE_ONDUTY:
        key = draft.OnDuty.findIndex(
          (CL) => CL.id === action.payload.id
        );
        draft.OnDuty[key] = action.payload;
        draft.businessTripId = -1;
        draft.error = "";
        break;
      case DELETE_ONDUTY:
        key = draft.OnDuty.findIndex(
          (CL) => CL.id === action.payload.id
        );
        draft.OnDuty.splice(key, 1);
        draft.businessTripId = -1;
        draft.error = "";
        break;
      case SET_ONDUTY_ID:
        draft.onDutyId = action.payload;
        break;
      default:
        return state;
    }
  });

export default onDutyReducer;
